import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[uppercase]'
})
export class UpperCaseDirective {

  constructor(public ref: ElementRef, private control: NgControl) { }

  @HostListener('input', ['$event']) input(event: any) {
    this.ref.nativeElement.value = event.target.value.toUpperCase();
    if (this?.control?.control) {
      this.control.control.setValue(this.ref.nativeElement.value);
    }
  }
}